import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Button,
  VStack,
  Text,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';

const EmailConfirmationModal = ({ isOpen, onClose, message }) => {
  const modeText = useColorModeValue('secondaryDark08', '#DDDDDD');

  const defaultMessage =
    "Please click the verification link we sent to the email address provided. Make sure to check your spam folder if you can't see it in your inbox.";

  return (
    <Modal onClose={onClose} isOpen={isOpen} size="xl">
      <ModalOverlay />
      <ModalContent px={6} w="100%">
        <ModalBody>
          <VStack spacing="30px" alignItems="center" mt="36px">
            <Text
              textStyle="headingFamilyBold"
              fontSize={{ base: '24px', lg: '32px' }}
              lineHeight="130%"
            >
              Email confirmation required
            </Text>
            <Box>
              <Text
                fontSize="16px"
                textStyle="bodyFamilyMedium"
                color={modeText}
              >
                {message || defaultMessage}
              </Text>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={onClose} alt="OK">
            OK
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EmailConfirmationModal;
